import { render } from "./FormDatosP.vue?vue&type=template&id=27b57c59"
import script from "./FormDatosP.vue?vue&type=script&lang=js"
export * from "./FormDatosP.vue?vue&type=script&lang=js"
script.render = render

export default script